/**
 * JWT Command
 * Decode and encode JWT tokens
 */
import { Command } from 'commander';
import { UtilsService } from '../../services/utils.service.js';

async function handleJwtDecode(token: string): Promise<void> {
    const service = new UtilsService();

    try {
        const { header, payload, signature } = service.jwtDecode(token);

        console.log('🔓 JWT Decoded:');
        console.log('────────────────────────────────────────\n');

        console.log('📋 Header:');
        console.log(JSON.stringify(header, null, 2));
        console.log();

        console.log('📄 Payload:');
        console.log(JSON.stringify(payload, null, 2));
        console.log();

        console.log('🔏 Signature:');
        console.log(`   ${signature}`);
        console.log();

        console.log('⚠️  Note: Token signature is not verified');
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

async function handleJwtEncode(options: {
    payload: string;
    secret: string;
    header?: string;
}): Promise<void> {
    const service = new UtilsService();

    try {
        const payload = JSON.parse(options.payload);
        const header = options.header ? JSON.parse(options.header) : undefined;

        const token = service.jwtEncode(payload, options.secret, header);

        console.log('🔐 JWT Encoded:');
        console.log('────────────────────────────────────────\n');
        console.log(`   ${token}`);
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createJwtCommand(): Command {
    const jwtCommand = new Command('jwt')
        .description('Decode and encode JWT tokens');

    // Decode subcommand
    jwtCommand
        .command('decode')
        .description('Decode JWT token')
        .argument('<token>', 'JWT token to decode')
        .addHelpText('after', `
Examples:
  $ jai1 utils jwt decode "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"
  $ jai1 utils jwt decode $JWT_TOKEN
`)
        .action(async (token) => {
            await handleJwtDecode(token);
        });

    // Encode subcommand
    const encodeCommand = jwtCommand
        .command('encode')
        .description('Encode JWT token (HS256)')
        .requiredOption('-p, --payload <json>', 'Payload as JSON string')
        .requiredOption('-s, --secret <secret>', 'Secret key for signing')
        .option('-h, --header <json>', 'Custom header as JSON string')
        .addHelpText('after', `
Examples:
  $ jai1 utils jwt encode --payload '{"sub":"123","name":"John"}' --secret "mysecret"
  $ jai1 utils jwt encode -p '{"userId":"456"}' -s "key123"
  $ jai1 utils jwt encode -p '{"sub":"789"}' -s "secret" -h '{"alg":"HS256","typ":"JWT"}'
`)
        .action(async (options) => {
            await handleJwtEncode(options);
        });

    // Show help on error for missing required options
    encodeCommand.showHelpAfterError('(add --help for additional examples)');

    return jwtCommand;
}
